import type { FaireProductEntity } from "../../entity_types/product";

export const p_kzznwb3tpr: FaireProductEntity = {
  token: "p_kzznwb3tpr",
  type: "product",
  name: "All Natural Hazelnut Chocolate Vegan French Macarons",
  brandToken: "b_384hnspyq8",
  brandName: "macaron centrale",
  imageUrl:
    "https://cdn.faire.com/fastly/08a1b9f36ac52a8aaa1a806551ca7e52ec733b68369cae62a8fa33b4cf9b56b5.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6224d3b92dff3b60c4e9143ec235783f0e07494a9446a1eae0647cb8a2a064f8.jpeg",
    "https://cdn.faire.com/fastly/b748d8108198bc6a8b2556caddd514b2543459bd8d9ea7437a9f321886fd89ed.jpeg",
    "https://cdn.faire.com/fastly/9f709b3753cee0b782b2190bad4f6fc0de3b8e199c9b3d7921bf124a8caf0f23.jpeg",
    "https://cdn.faire.com/fastly/80b9de104b6f8664dc61f7caebd494688a4607aaf7ca5d8ec2bf896fcae12b92.jpeg",
  ],
  priceDollars: 2.29,
  description:
    "Savor the rich harmony of roasted hazelnuts and smooth chocolate with our Hazelnut Chocolate Naturally Vegan Macarons. Each bite captures the indulgent flavor profile you love from classic hazelnut spreads, but in a light, delicate French macaron — plant-based and crafted without compromise.\n\nOur vegan recipe is made with no artificial colors or ingredients, ensuring every shell and filling is as clean as it is delicious. The chocolate-hazelnut filling is creamy, satisfying, and reminiscent of your favorite Nutella-style treat, while the crisp outer shells provide that signature macaron texture.\n\n✨ Available in multiple pack sizes, these macarons make the perfect gift, party centerpiece, or personal indulgence. Thoughtfully handcrafted to impress both taste and presentation.\n\nWhy You’ll Love Them:\n\nNaturally vegan and dairy-free\nNo artificial colors or additives\nFlavor profile similar to Nutella — rich hazelnut & chocolate blend\nHandcrafted fresh and shipped with care\nBring a touch of all-natural indulgence to your dessert table — perfect for gifting, sharing, or treating yourself.",
  tags: [],
  msrpDollars: 4.57,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:54:57.108Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
